
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extra/browser-incompatibility",
      function () {
        return require("private-next-pages/extra/browser-incompatibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extra/browser-incompatibility"])
      });
    }
  